import Api from "./Api";

export default {
  getFinances() {
    return Api().get("customer/getAccount");
  },
  getCatalogue() {
    return Api().get("customer/getCatalogue");
  },
};
